/**
 * The A2A channel must be used for all the real-time communication between the
 * real-time servers.
 */
export const FLUX_REALTIME_POSTGRES_CHANNEL_CLUSTER = 'isengard_realtime_pub_sub:inter_cluster';

/**
 * The A2C channel must be used for all the real-time communication between the
 * real-time servers and the clients.
 */
export const FLUX_REALTIME_POSTGRES_CHANNEL_CLIENT = 'isengard_realtime_pub_sub:server_client';
